import React from 'react';
import { SvgIcon, Tabs, Tab } from '@mui/material';
import getMuiIcon, { IconName } from '../../../utils/getMuiIcon';
import useScreenSize from '../../../utils/useScreenSize';

export type ItemsTab<T = string> = {
  key: T;
  name: string;
  icon: IconName;
};

interface OwnProps {
  tabs: ItemsTab[];
  handleChange: (event: React.SyntheticEvent, newValue: number) => void;
  value: string;
}

const getIconName = (icon: string, key: string, value: string): IconName => {
  return key === value ? `${icon}Bold` as IconName : icon as IconName;
};

const MuTabsNewUI: React.FC<OwnProps> = (props) => {
  const { isXsScreen } = useScreenSize();
  const tabIndex: number = props.tabs.findIndex(tab => tab.key === props.value);
  return props.tabs.length > 1 ? (
    <Tabs
      value={tabIndex}
      onChange={props.handleChange}
      variant='scrollable'
      scrollButtons={false}
    >
      {props.tabs.map((tab, index) => (
        <Tab
          key={tab.key}
          sx={{
            fontSize: '16px',
            lineHeight: '26px',
            minHeight: '48px',
            letterSpacing: '0.46px',
            textTransform: 'none',
            '& .MuiTouchRipple-root': {
              color: 'transparent',
            },
            cursor: 'pointer',
          }}
          icon={
            !isXsScreen ?
              <SvgIcon component={getMuiIcon(getIconName(tab.icon, tab.key, props.value))} /> :
              <></>
          }
          iconPosition='start'
          label={tab.name}
          data-testid={`tabs__${tab.key}`}
          value={index}
        />
      ))}
    </Tabs>
  ) : null;
};

export default MuTabsNewUI;
